
define('template!webshopMenuEditorView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (!node) { ;
__p += '\n<div class="mm-editor-empty">\n    <i class="fa fa-hand-pointer-o"></i>\n    <div>' +
((__t = ( _.i18n('webshop.menu.selectItem', null, 'Select an item of the menu to edit it, or drag the items to reorder them.') )) == null ? '' : __t) +
'</div>\n</div>\n';
 } else { ;
__p += '\n<div class="mm-editor-header">\n    <div class="mm-breadcrumb">\n        ';
 _.each(breadcrumb, function (crumb, i) { ;
__p += '\n            ';
 if (i > 0) { ;
__p += '<i class="fa fa-angle-right"></i>';
 } ;
__p += '\n            <span class="mm-crumb" data-uid="' +
__e( crumb.uid ) +
'">' +
__e( crumb.label ) +
'</span>\n        ';
 }); ;
__p += '\n    </div>\n    <div class="mm-editor-title">\n        <span class="mm-kind kind-' +
__e( kind ) +
'">' +
__e( kindLabel ) +
'</span>\n        <span class="mm-editor-help">' +
__e( kindHelp ) +
'</span>\n    </div>\n</div>\n\n<div class="mm-editor-fields">\n    ';
 if (kind === 'top') { ;
__p += '\n    <div class="mm-field mm-field-wide">\n        <label>' +
((__t = ( _.i18n('webshop.menu.field.type', null, 'Type') )) == null ? '' : __t) +
'</label>\n        <div class="mm-types">\n            ';
 _.each(types, function (type) { ;
__p += '\n            <label class="mm-type ';
 if (type.value === node.Type) { ;
__p += 'selected';
 } ;
__p += '">\n                <input type="radio" name="mm-type" value="' +
__e( type.value ) +
'" ';
 if (type.value === node.Type) { ;
__p += 'checked';
 } ;
__p += '/>\n                <i class="fa ' +
__e( type.icon ) +
'"></i>\n                <span class="mm-type-name">' +
__e( type.label ) +
'</span>\n                <span class="mm-type-help">' +
__e( type.help ) +
'</span>\n            </label>\n            ';
 }); ;
__p += '\n        </div>\n    </div>\n    ';
 } ;
__p += '\n\n    <div class="mm-field">\n        <label>' +
((__t = ( _.i18n('webshop.menu.field.name', null, 'Name') )) == null ? '' : __t);
 if (nameRequired) { ;
__p += ' *';
 } ;
__p += '</label>\n        <input type="text" data-field="Name" value="' +
__e( node.Name || '' ) +
'" placeholder="' +
__e( namePlaceholder ) +
'"/>\n        ';
 if (!nameRequired) { ;
__p += '<div class="mm-hint">' +
((__t = ( _.i18n('webshop.menu.hint.name', null, 'Empty: name of the category on the site') )) == null ? '' : __t) +
'</div>';
 } ;
__p += '\n    </div>\n\n    ';
 if (showCode) { ;
__p += '\n    <div class="mm-field">\n        <label>' +
((__t = ( _.i18n('webshop.menu.field.category', null, 'Category') )) == null ? '' : __t);
 if (codeRequired) { ;
__p += ' *';
 } ;
__p += '</label>\n        <div class="mm-input-group">\n            <input type="text" data-field="Code" value="' +
__e( node.Code || '' ) +
'" placeholder="' +
((__t = ( _.i18n('webshop.menu.hint.code', null, 'Category code') )) == null ? '' : __t) +
'"/>\n            <button class="mm-btn mm-find-category" title="' +
((__t = ( _.i18n('webshop.menu.findCategory', null, 'Find a category') )) == null ? '' : __t) +
'"><i class="fa fa-search"></i></button>\n        </div>\n        <div class="mm-category-info"></div>\n        ';
 if (codeHelp) { ;
__p += '<div class="mm-hint">' +
__e( codeHelp ) +
'</div>';
 } ;
__p += '\n    </div>\n    ';
 } ;
__p += '\n\n    ';
 if (showUrl) { ;
__p += '\n    <div class="mm-field">\n        <label>' +
((__t = ( _.i18n('webshop.menu.field.url', null, 'Link') )) == null ? '' : __t);
 if (urlRequired) { ;
__p += ' *';
 } ;
__p += '</label>\n        <input type="text" data-field="Url" value="' +
__e( node.Url || '' ) +
'" placeholder="/demande-de-devis-gratuit/"/>\n        <div class="mm-hint">' +
__e( urlHelp ) +
'</div>\n    </div>\n    ';
 } ;
__p += '\n\n    ';
 if (showTag) { ;
__p += '\n    <div class="mm-field">\n        <label>' +
((__t = ( _.i18n('webshop.menu.field.tag', null, 'Badge') )) == null ? '' : __t) +
'</label>\n        <input type="text" data-field="Tag" value="' +
__e( node.Tag || '' ) +
'" list="mm-tags" placeholder="' +
((__t = ( _.i18n('webshop.menu.hint.tagPlaceholder', null, 'e.g. populaire, nouveau') )) == null ? '' : __t) +
'"/>\n        <datalist id="mm-tags">\n            ';
 _.each(tags, function (tag) { ;
__p += '<option value="' +
__e( tag ) +
'"></option>';
 }); ;
__p += '\n        </datalist>\n        <div class="mm-hint">' +
((__t = ( _.i18n('webshop.menu.hint.tag', null, 'Small badge shown next to the link') )) == null ? '' : __t) +
'</div>\n    </div>\n    ';
 } ;
__p += '\n\n    ';
 if (showImage) { ;
__p += '\n    <div class="mm-field mm-field-wide">\n        <label>' +
((__t = ( _.i18n('webshop.menu.field.image', null, 'Image') )) == null ? '' : __t);
 if (imageRequired) { ;
__p += ' *';
 } ;
__p += '</label>\n        <div class="mm-image-field">\n            <div class="mm-image-thumb">\n                ';
 if (imageSrc) { ;
__p += '<img src="' +
__e( imageSrc ) +
'"/>';
 } else { ;
__p += '<i class="fa fa-picture-o"></i>';
 } ;
__p += '\n            </div>\n            <div class="mm-image-inputs">\n                <div class="mm-input-group">\n                    <input type="text" data-field="ImageUrl" value="' +
__e( node.ImageUrl || '' ) +
'" placeholder="sections_images/..."/>\n                    <button class="mm-btn mm-choose-image"><i class="fa fa-picture-o"></i> ' +
((__t = ( _.i18n('webshop.menu.chooseImage', null, 'Choose') )) == null ? '' : __t) +
'</button>\n                    ';
 if (node.ImageUrl) { ;
__p += '<button class="mm-btn mm-icon mm-clear-image" title="' +
((__t = ( _.i18n('webshop.menu.removeImage', null, 'Remove the image') )) == null ? '' : __t) +
'"><i class="fa fa-times"></i></button>';
 } ;
__p += '\n                </div>\n                <div class="mm-hint">' +
__e( imageHelp ) +
'</div>\n            </div>\n        </div>\n    </div>\n    ';
 } ;
__p += '\n</div>\n\n';
 if (problems.length) { ;
__p += '\n<div class="mm-editor-problems">\n    ';
 _.each(problems, function (p) { ;
__p += '\n    <div class="mm-problem ' +
__e( p.level ) +
'"><i class="fa fa-exclamation-triangle"></i> ' +
__e( p.message ) +
'</div>\n    ';
 }); ;
__p += '\n</div>\n';
 } ;
__p += '\n\n<div class="mm-editor-actions">\n    ';
 if (childLabel) { ;
__p += '\n    <button class="mm-btn" data-action="add-child"><i class="fa fa-plus"></i> ' +
__e( childLabel ) +
'</button>\n    ';
 } ;
__p += '\n    <button class="mm-btn" data-action="add-sibling"><i class="fa fa-plus"></i> ' +
__e( siblingLabel ) +
'</button>\n    <button class="mm-btn mm-icon" data-action="up" title="' +
((__t = ( _.i18n('webshop.menu.moveUp', null, 'Move up') )) == null ? '' : __t) +
'" ';
 if (!canMoveUp) { ;
__p += 'disabled';
 } ;
__p += '><i class="fa fa-arrow-up"></i></button>\n    <button class="mm-btn mm-icon" data-action="down" title="' +
((__t = ( _.i18n('webshop.menu.moveDown', null, 'Move down') )) == null ? '' : __t) +
'" ';
 if (!canMoveDown) { ;
__p += 'disabled';
 } ;
__p += '><i class="fa fa-arrow-down"></i></button>\n    <button class="mm-btn" data-action="duplicate"><i class="fa fa-clone"></i> ' +
((__t = ( _.i18n('webshop.menu.duplicate', null, 'Duplicate') )) == null ? '' : __t) +
'</button>\n    <button class="mm-btn mm-danger" data-action="delete"><i class="fa fa-trash-o"></i> ' +
((__t = ( _.i18n('common.delete', null, 'Delete') )) == null ? '' : __t) +
'</button>\n</div>\n';
 } ;
__p += '\n';

}
return __p
};});

